module.exports = __webpack_public_path__ + "static/media/map.d7d5bf8d.png";